"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const AuthContext_1 = require("./AuthContext");
function useAuth() {
    const auth = react_1.useContext(AuthContext_1.AuthContext);
    return auth;
}
exports.useAuth = useAuth;
//# sourceMappingURL=useAuth.js.map